import React, { useRef, useState } from "react";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import { ListPlus, ClipboardPenLine, Eye, ListMinus, ChevronUp, ChevronDown, FileUp, Plus, Minus, Trash2,Globe } from "lucide-react";
import Modal from "../Elements/Modal";
import AccordionItem from "../Elements/AccordionItem";
import FieldValidation from "./FieldValidation";
import * as XLSX from 'xlsx';

interface FieldEditorProps {
    isOpen: boolean;
    onClose: () => void;
    field?: FieldFrm;
    onSave: (updatedField: FieldFrm) => void;
    fields: FieldFrm[];
}
const fieldTypes = ["text", "email", "number", "password", "date-range", "select", "api-search", "radio", "checkbox"];
 

const FieldEditor: React.FC<FieldEditorProps> = ({ isOpen, onClose, field, onSave,fields }) => {
  const {
    register,
    control,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
    } = useForm<FieldFrm>({
    defaultValues: {
        ...field,
        apiConfig: {
        url: field?.apiConfig?.url || "",
        method: field?.apiConfig?.method || "GET",
        campo: field?.apiConfig?.campo || "",
        campo_response: field?.apiConfig?.campo_response || "",
        headers: field?.apiConfig?.headers || []
        }
    }
    });
  const { fields: headerFields, append: appendHeader, remove: removeHeader } =
  useFieldArray({
    control,
    name: "apiConfig.headers"
  });

  const watchedType = watch("type");
  const watchedOptions = watch("options") || [];
  const watchedValidations = watch("validations") || {};
  
  const addOption = () => {
    setValue("options", [{ label: "", value: "" },...watchedOptions]);
  };

  const removeOption = (index: number) => {
    const updatedOptions = watchedOptions.filter((_, i) => i !== index);
    setValue("options", updatedOptions);
  };

  const onSubmit = (data: FieldFrm) => { 
    if(["select", "radio", "checkbox"].includes(data.type)){ 
        if(data.options?.length==undefined){
            console.error("agrear opciones");
            return;    
        } 
    }else{
        data.options=[] 
    } 
    if (data.type !== "api-search") {
    data.apiConfig = undefined;
    }
    console.log("Datos del campo a guardar:", data);
    onSave(data);
     onClose();
  };



  const [openIndexAcordion, setOpenIndexAcordion] = useState<number | null>(null);
  const [openEndpointConfig, setOpenEndpointConfig] = useState(false);
  const handleOpenAcordion = (index: number) => {
    setOpenIndexAcordion(openIndexAcordion === index ? null : index);
  };

// carga opciones select, check, radio
    const fileInputRefXlsx = useRef<HTMLInputElement | null>(null); 
    // const [options, setOptions] = useState<{ label: string; value: string }[]>([]);
    
    const handleFileUploadXlsx = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (!file) {
            console.warn("No se seleccionó ningún archivo.");
            return;
        }
    
        const reader = new FileReader();
        
        reader.onload = (e) => {
            try {
                const data = new Uint8Array(e.target?.result as ArrayBuffer);
                const workbook = XLSX.read(data, { type: "array" });
    
                // Obtener la primera hoja del Excel
                const sheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[sheetName]; 
                
                // Convertir la hoja a JSON
                const jsonData: { label: string; value: string }[] = XLSX.utils.sheet_to_json(worksheet, { header: 1 })
                    .slice(1) // Omitir los encabezados
                    .filter((row: any) => row.length >= 2) // Validar filas con al menos 2 columnas
                    .map((row: any) => ({
                        value: row[0]?.toString() || "",
                        label: row[1]?.toString() || ""
                    }));
                if (jsonData.length === 0) {
                    console.warn("⚠️ No se encontraron datos válidos en el archivo.");
                    return;
                }
                const currentOptions = watch("options") || []; 
                setValue("options", [...currentOptions, ...jsonData]);
    
            } catch (error) {
                console.error("❌ Error procesando el archivo Excel:", error);
            }
        };
    
        reader.readAsArrayBuffer(file); // Leer el archivo como ArrayBuffer
    };

    
    const handleButtonClickXlsx = () => { 
    fileInputRefXlsx.current?.click(); 
    };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
        <h3 className="text-lg font-bold py-4 px-5">Elemento(s) del formulario</h3>
            <form onSubmit={handleSubmit(onSubmit)} className="">
                <div className="overflow-auto px-8 py-2
                      min-w-[400px] max-w-[600px] 
                      sm:min-w-[600px] sm:max-w-[100%] 
                      md:min-w-[700px] md:max-w-[799px] 
                      lg:min-w-[800px] lg:max-w-[800px]

                      min-h-[100px] max-h-[200px] 
                      sm:min-h-[200px] sm:max-h-[100%s] 
                      md:min-h-[250px] md:max-h-[300px] 
                      lg:min-h-[300px] lg:max-h-[100%]">

                    <label className="block text-gray-700" >Tipo</label>
                    <Controller
                        name="type"
                        control={control}
                        render={({ field }) => (
                            <div className="relative"> 
                                <select {...field} 
                                    className= {`appearance-none w-full border n-fmr-input px-4 pr-4 py-2 border-gray-300 focus:outline-none focus:ring-1 focus:ring-blue-700`}>
                                    {fieldTypes.map((type) => (
                                    <option key={type} value={type}>
                                        {type}
                                    </option>
                                    ))}
                                </select>
                                <ChevronDown className="w-5 h-5 absolute inset-y-0 top-3 right-3 pointer-events-none text-gray-400" /> 
                        </div>
                        )}
                    />

                    <div className="flex justify-between items-center w-full">
                        <div className="w-1/2">
                            <label className="block text-gray-700" >Etiqueta(Formulario)</label>
                            <input 
                                {...register("label", { required: "La etiqueta es obligatoria" })}
                                className="border w-full p-2 n-fmr-input focus:outline-none focus:ring-1 focus:ring-blue-700"
                                placeholder="Etiqueta" />
                            {errors.label && <p className="text-red-500">{errors.label.message}</p>}
                        </div>
                        <div className="w-1/2 ml-2">
                            <label className="block text-gray-700" >Etiqueta {["date-range"].includes(watchedType) && ("Inicio")}(Endpoint) </label>
                            <input
                                {...register("nameStart", { required: "La Etiqueta (Endpoint) es obligatorio" })}
                                className="border w-full p-2 n-fmr-input focus:outline-none focus:ring-1 focus:ring-blue-700"
                                placeholder="Nombre" />
                            {errors.nameStart && <p className="text-red-500">{errors.nameStart.message}</p>}
                        </div>
                        
                        {["date-range"].includes(watchedType) && (

                            <div className="w-1/2 ml-2">
                                <label className="block text-gray-700" >Etiqueta Final(Endpoint)</label>
                                <input
                                    {...register("nameEnd", { required: "La Etiqueta Final(Endpoint) es obligatorio" })}
                                    className="border w-full p-2 n-fmr-input focus:outline-none focus:ring-1 focus:ring-blue-700"
                                    placeholder="Nombre" />
                                {errors.nameEnd && <p className="text-red-500">{errors.nameEnd.message}</p>}
                            </div>
                        )}

                        

                    </div> 

                    <div className="flex justify-between items-center w-full">
                        <div className="w-4/5 mr-2">
                            <label className="block text-gray-700" >Valor inicial</label>
                            <input
                                {...register("defaultValue")}
                                className="border w-full p-2 n-fmr-input focus:outline-none focus:ring-1 focus:ring-blue-700"
                                placeholder="Valor Inicial" /> 
                        </div>
                        <div className="w-1/5">
                            <label className="block text-gray-700" >Oculto</label>
                            <input 
                                {...register("hidden")}
                                type="checkbox"
                                className="border n-fmr-input focus:outline-none focus:ring-1 focus:ring-blue-700 w-5 h-5"
                                placeholder="Oculto" />
                            
                        </div>
                    </div> 
                    <div className="w-full"> 
                        {/* Opciones para select, radio, checkbox */}
                        {["select", "radio", "checkbox"].includes(watchedType) && (
                            <AccordionItem title="Opciones" index={0} isOpen={openIndexAcordion === 0} onClick={handleOpenAcordion} className="mt-2">
                                <div className="relative">
                                    <button
                                        type="button" 
                                        onClick={addOption}
                                        className={`absolute -top-10 right-3 btn-inca-secondary shadow-md rounded-full transition-all duration-500 transform`}
                                    >
                                        <Plus className="w-5 h-5 m-2" strokeWidth={1.5} />
                                    </button> 
                                    <input 
                                        type="file"
                                        ref={fileInputRefXlsx} 
                                        accept=".xlsx, .xls" 
                                        onChange={handleFileUploadXlsx}
                                        className="hidden" 
                                        /> 
                                    <button
                                        type="button" 
                                        onClick={handleButtonClickXlsx}
                                        className={`absolute -top-10 right-14 btn-inca-secondary shadow-md rounded-full transition-all duration-500 transform`}
                                    >
                                        <FileUp className="w-5 h-5 m-2" strokeWidth={1.5} />
                                    </button> 
                                    
                                    
                                    <button
                                        type="button" 
                                        onClick={() => setOpenEndpointConfig(true)}
                                        className="absolute -top-10 right-24 btn-inca-secondary shadow-md rounded-full transition-all duration-500 transform"
                                    >
                                        <Globe className="w-5 h-5 m-2" strokeWidth={1.5} />
                                    </button>
                                    
                                </div>
                                <div className="max-h-48 overflow-y-auto py-2 px-4">
                                    {watchedOptions.map((_, optIndex) => (
                                        <div key={optIndex} className="flex space-x-2 mt-2">
                                            <input 
                                                {...register(`options.${optIndex}.label`, { required: "La etiqueta es obligatoria" })}                                                
                                                placeholder="Etiqueta(formulario)" 
                                                className="border w-full p-2 n-fmr-input focus:outline-none focus:ring-1 focus:ring-blue-700"
                                                />
                                            <input
                                                {...register(`options.${optIndex}.value`, { required: "La etiqueta es obligatoria" })} 
                                                placeholder="Valor(endpoint)" 
                                                className="border w-full p-2 n-fmr-input focus:outline-none focus:ring-1 focus:ring-blue-700"
                                                /> 
                                            <button
                                                type="button"
                                                onClick={() => removeOption(optIndex)}
                                                className={`flex items-center justify-center w-9 h-9 btn-inca-secondary shadow-md rounded-full transition-all duration-500 transform mt-1`}
                                            >
                                                <Trash2 className="w-5 h-5 m-2" strokeWidth={1.5} />
                                            </button>
                                        </div>
                                    ))}
                                </div>
                            </AccordionItem>
                        )} 

                        {["api-search"].includes(watchedType) && (
                            <AccordionItem title="Configuración API" index={0} isOpen={openIndexAcordion === 0} onClick={handleOpenAcordion} className="mt-2">
                               {/* URL */}
                                <div className="m-4">
                                    <label className="block text-sm font-medium mb-1">
                                        URL
                                    </label>
                                    <input
                                    {...register("apiConfig.url")}
                                    type="text"
                                    placeholder="https://api.midominio.com/options"
                                    className="border w-full p-2 n-fmr-input focus:outline-none focus:ring-1 focus:ring-blue-700"
                                    />
                                </div>

                                {/* Método */}
                                <div className="m-4">
                                    <label className="block text-sm font-medium mb-1">
                                        Método
                                    </label>
                                    <select  {...register("apiConfig.method")} className="border w-full p-2 n-fmr-input focus:outline-none focus:ring-1 focus:ring-blue-700">
                                        <option value="GET">GET</option>
                                        <option value="POST">POST</option>
                                        <option value="PUT">PUT</option>
                                        <option value="DELETE">DELETE</option>
                                    </select>
                                </div>
                                <div className="m-4">
                                    <label className="block text-sm font-medium mb-1">
                                        Campo de consulta (query)
                                    </label>
                                    <input
                                    {...register("apiConfig.campo")}
                                    type="text"
                                    className="border w-full p-2 n-fmr-input focus:outline-none focus:ring-1 focus:ring-blue-700"
                                    />
                                </div>
                                <div className="m-4">
                                    <label className="block text-sm font-medium mb-1">
                                        Campo de response a usar
                                    </label>
                                    <input
                                    {...register("apiConfig.campo_response")}
                                    type="text"
                                    className="border w-full p-2 n-fmr-input focus:outline-none focus:ring-1 focus:ring-blue-700"
                                    />
                                </div>
                                {/* Headers */}
                                <div className="flex justify-between items-center m-4">
                                <span className="mt-1 font-medium">Encabezados (Headers)</span>
                                <button
                                    type="button"
                                    onClick={() => appendHeader({ key: "", value: "" })}
                                    disabled={headerFields.length >= 5}
                                    className={`flex items-center justify-center w-10 h-10 rounded-full transition-colors border shadow-md
                                    ${headerFields.length >= 5
                                        ? "bg-gray-200 cursor-not-allowed text-gray-400"
                                        : "bg-gray-100 hover:bg-gray-200 btn-inca-secondary border-gray-300"}`}
                                >
                                    <Plus className="w-5 h-5" strokeWidth={1.5} />
                                </button>
                                </div>

                                {headerFields.map((header, index) => (
                                <div
                                    key={header.id}
                                    className="flex flex-col md:flex-row gap-2 items-start md:items-center m-4 border rounded-2xl p-3 bg-white shadow-sm"
                                >
                                    <div className="flex-1 w-full">
                                    <input
                                        placeholder="Clave"
                                        {...register(`apiConfig.headers.${index}.key`, {
                                        required: "Clave obligatoria"
                                        })}
                                        className="w-full border n-fmr-input px-3 py-2 border-gray-300 focus:outline-none focus:ring-1 focus:ring-blue-700"
                                    />
                                    </div>

                                    <div className="flex-1 w-full">
                                    <input
                                        placeholder="Valor"
                                        {...register(`apiConfig.headers.${index}.value`, {
                                        required: "Valor obligatorio"
                                        })}
                                        className="w-full border n-fmr-input px-3 py-2 border-gray-300 focus:outline-none focus:ring-1 focus:ring-blue-700"
                                    />
                                    </div>

                                    <button
                                    type="button"
                                    onClick={() => removeHeader(index)}
                                    className="btn-inca-secondary shadow-md rounded-full w-9 h-9 border border-gray-300 flex items-center justify-center mt-1 md:mt-0"
                                    >
                                    <Trash2 className="w-4 h-4 text-gray-700" strokeWidth={1.5} />
                                    </button>
                                </div>
                                ))}

                            </AccordionItem>
                        )} 
                        <AccordionItem title="Validaciones" index={1} isOpen={openIndexAcordion === 1} onClick={handleOpenAcordion} className="mt-2">
                        <FieldValidation 
                            register={register} 
                            setValue={setValue} 
                            watch={watch} 
                            field={field}
                            fields={fields}
                            />
                        </AccordionItem>
                    </div> 
                </div> 
                {/* Botones de acción */}
                <div className="flex justify-end gap-2 px-5 py-5">
                    <button type="button" onClick={onClose} 
                        className="bg-gray-200 hover:bg-gray-300 text-gray-700  py-2 px-4 mr-2 n-fmr-input focus:outline-none focus:ring-1 focus:ring-blue-700">
                        Cancelar
                    </button> 
                    <button type="submit" 
                        className="bg-blue-600 hover:bg-blue-700 text-white py-2 px-4 n-fmr-input focus:outline-none focus:ring-1 focus:ring-blue-700">
                        Guardar
                    </button>
                </div>
            </form>
        
    </Modal>
  );
};

export default FieldEditor;
